export default __webpack_public_path__ + "static/media/Rita_9781408355244.e3c10914.jpg";